<template>
    <div></div>
</template>

<script>
export default {
    name: "stock-save-redirect",
    created() {
        const id = this.$route.params.id;
        const target = id && id > 0 ? `/stock/detail/${id}` : '/stock/detail/new';
        this.$router.replace(target);
    },
}
</script>
